<template>
    <div class="lite_popup add_drive" v-show="auth.show && !hidePopup">
        <div class="lite_popup_box">
            <div class="lite_popup_title">
                <span>{{ auth.did ? $t('language.leftBanner.edit') : $t('language.common.addCloud') }}</span>
                <div class="icon white-close dialog-close" @click="auth.show = false"></div>
            </div>
            <div class="lite_popup_content">
                <el-form :model="auth" label-width="110px">
                    <!-- 一般云盘 -->
                    <el-form-item :label="$t('language.common.type')" style="display:none;">
                        <el-input v-model="auth.type" disabled></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('language.popup.addCloudPopup.cloudName')">
                        <el-input v-model="auth.name"></el-input>
                    </el-form-item>
                    <!-- FTP -->
                    <div v-if="auth.type == 'FTP'">
                        <el-form-item :label="$t('language.popup.addCloudPopup.protocol')">
                            <el-select v-model="auth.ftp.protocol">
                                <el-option label="ftp-plain" value="ftp-plain"></el-option>
                                <el-option label="ftps-explicit" value="ftps-explicit"></el-option>
                                <el-option label="ftps-implicit" value="ftps-implicit"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.server')">
                            <el-input v-model="auth.ftp.host" :disabled="auth.did!=null"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.port')">
                            <el-input v-model="auth.ftp.port" :disabled="auth.did!=null"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.userName')">
                            <el-input v-model="auth.ftp.username" :disabled="auth.did!=null"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.passWord')">
                            <el-input v-model="auth.ftp.password" show-password></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.passive')">
                            <div class="switch-box">
                                <el-switch v-model="auth.ftp.passive" active-color="#5166BD"></el-switch>
                            </div>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.encoding')">
                            <el-select v-model="auth.ftp.encoding">
                                <el-option label="ISO-8859-1" value="ISO-8859-1"></el-option>
                                <el-option label="UTF-8" value="UTF-8"></el-option>
                                <el-option label="GBK" value="GBK"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.path')">
                            <el-input v-model="auth.ftp.path"></el-input>
                        </el-form-item>
                    </div>
                    <!-- SFTP -->
                    <div v-if="auth.type == 'SFTP'">
                        <el-form-item :label="$t('language.popup.addCloudPopup.server')">
                            <el-input v-model="auth.sftp.host" :disabled="auth.did!=null"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.port')">
                            <el-input v-model="auth.sftp.port" :disabled="auth.did!=null"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.userName')">
                            <el-input v-model="auth.sftp.username" :disabled="auth.did!=null"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.passWord')">
                            <el-input v-model="auth.sftp.password" show-password></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.privateKey')">
                            <el-input v-model="auth.sftp.privateKey" type="textarea"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.passphrase')">
                            <el-input v-model="auth.sftp.passphrase" show-password></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.path')">
                            <el-input v-model="auth.sftp.path"></el-input>
                        </el-form-item>
                    </div>
                    <!-- WebDAV -->
                    <div v-if="auth.type == 'WebDAV'">
                        <el-form-item :label="$t('language.popup.addCloudPopup.server')">
                            <el-input v-model="auth.webdav.url" :disabled="auth.did!=null"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.userName')">
                            <el-input v-model="auth.webdav.username" :disabled="auth.did!=null"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.passWord')">
                            <el-input v-model="auth.webdav.password" show-password></el-input>
                        </el-form-item>
                    </div>
                    <!-- MySQL -->
                    <div v-if="auth.type == 'MySQL'">
                        <el-form-item :label="$t('language.popup.addCloudPopup.server')">
                            <el-input v-model="auth.mysql.host" :disabled="auth.did!=null"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.port')">
                            <el-input v-model="auth.mysql.port" :disabled="auth.did!=null"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.userName')">
                            <el-input v-model="auth.mysql.username" :disabled="auth.did!=null"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.passWord')">
                            <el-input v-model="auth.mysql.password" show-password></el-input>
                        </el-form-item>
                    </div>
                    <!-- Backblaze -->
                    <div v-if="auth.type == 'Backblaze'">
                        <el-form-item :label="$t('language.popup.addCloudPopup.keyID')">
                            <el-input v-model="auth.backblaze.applicationKeyId" :disabled="auth.did!=null"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.applicationKey')">
                            <el-input v-model="auth.backblaze.applicationKey" :disabled="auth.did!=null" show-password></el-input>
                        </el-form-item>
                    </div>
                    <!-- MediaFire -->
                    <div v-if="auth.type == 'MediaFire'">
                        <el-form-item :label="$t('language.popup.email')">
                            <el-input v-model="auth.mediafire.email"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('language.popup.addCloudPopup.passWord')">
                            <el-input v-model="auth.mediafire.password" show-password></el-input>
                        </el-form-item>
                    </div>
                    <!-- Website -->
                     <div v-if="auth.type == 'Website'">
                        <!-- 站点 -->
                        <div class="website_box">
                            <!-- 标题 -->
                            <div class="website_box_title">
                                <div class="website_box_title_text">{{ $t('language.website.addSite') }}</div>
                                <div class="website_box_title_add" @click="addSite()">{{ $t('language.website.addSiteMore') }}</div>
                            </div>
                            <!-- 子集合 -->
                            <div class="website_items myscroll">
                                <div class="website_item2" v-for="(site, index) in auth.website.sites" :key="index">
                                    <!-- 基本参数 -->
                                    <el-form-item :label="$t('language.popup.addCloudPopup.server') + ' ' + (index + 1)">
                                        <span class="website_host_prefix">sftp://</span>
                                        <el-input class="website_host" v-model="site.host"></el-input>
                                        <el-input class="website_port" v-model="site.port"></el-input>
                                    </el-form-item>
                                    <el-form-item :label="$t('language.popup.addCloudPopup.userName')">
                                        <el-input v-model="site.username"></el-input>
                                    </el-form-item>
                                    <el-form-item :label="$t('language.popup.addCloudPopup.passWord')">
                                        <el-input v-model="site.password" show-password></el-input>
                                    </el-form-item>
                                    <!-- 更多 -->
                                    <div class="website_more">
                                        <div class="website_more_btn" @click="site.show=!site.show">{{ $t('language.popup.addCloudPopup.advanced') }}</div>
                                        <div class="website_more_remove" @click="delSite(index)">{{ $t('language.website.removeSite') }}</div>
                                    </div>
                                    <!-- 高级参数 -->
                                    <div class="website_more_content" v-show="site.show">
                                        <el-form-item label="Private Key">
                                            <el-input v-model="site.privateKey" type="textarea"></el-input>
                                        </el-form-item>
                                        <el-form-item :label="$t('language.popup.addCloudPopup.passphrase')">
                                            <el-input v-model="site.passphrase" show-password></el-input>
                                        </el-form-item>
                                        <el-form-item :label="$t('language.popup.addCloudPopup.path')">
                                            <el-input v-model="site.path"></el-input>
                                        </el-form-item>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 数据库 -->
                         <div class="website_box">
                            <!-- 标题 -->
                            <div class="website_box_title">
                                <div class="website_box_title_text">{{ $t('language.website.addDb') }}</div>
                                <div class="website_box_title_add" @click="addDB()">{{ $t('language.website.addDbMore') }}</div>
                            </div>
                            <!-- 子集合 -->
                             <div class="website_items myscroll">
                                <div class="website_item2 website_item_db" v-for="(db, index) in auth.website.dbs" :key="index">
                                    <!-- 基本参数 -->
                                    <el-form-item :label="$t('language.popup.addCloudPopup.server') + ' ' + (index + 1)">
                                        <el-input class="website_host" v-model="db.host"></el-input>
                                        <el-input class="website_port" v-model="db.port"></el-input>
                                    </el-form-item>
                                    <el-form-item :label="$t('language.popup.addCloudPopup.userName')">
                                        <el-input v-model="db.username"></el-input>
                                    </el-form-item>
                                    <el-form-item :label="$t('language.popup.addCloudPopup.passWord')">
                                        <el-input v-model="db.password" show-password></el-input>
                                    </el-form-item>
                                    <!-- 更多 -->
                                    <div class="website_more">
                                        <div class="website_more_btn" @click="db.show=!db.show">{{ $t('language.popup.tips') }}</div>
                                        <div class="website_more_remove" @click="delDB(index)">{{ $t('language.website.removeDb') }}</div>
                                    </div>
                                    <!-- 提示信息 -->
                                    <div class="website_more_content" v-show="db.show">
                                        <!-- <ul>
                                            <li>xxxxxxxxxx</li>
                                            <li>xxxxxxxxxx</li>
                                            <li>xxxxxxxxxx</li>
                                        </ul> -->
                                    </div>
                                </div>
                            </div>
                         </div>
                     </div>
                </el-form>
            </div>
            <div class="lite_popup_footer">
                <button @click="submit()">
                    <i v-if="auth.loading" class="el-icon-loading" style="color:#fff;"></i>
                    <span>{{ auth.did ? $t('language.leftBanner.edit') : $t('language.common.addCloud') }}</span>
                </button>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    props: {
        auth: Object,
    },
    methods: {
        submit() {
            this.$emit('submit');
        },
        addSite() {
            let sftp = {
                host: '',
                port: '22',
                username: '',
                password: '',
                privateKey: '',
                passphrase: '',
                path: '',
                show: false,
            };
            this.auth.website.sites.push(sftp);
        },
        delSite(index) {
            this.auth.website.sites.splice(index, 1);
        },
        addDB() {
            let db = {
                host: '',
                port: '3306',
                username: '',
                password: '',
                show: false,
            };
            this.auth.website.dbs.push(db);
        },
        delDB(index) {
            this.auth.website.dbs.splice(index, 1);
        },
    },
    computed: {
        hidePopup() {
            return ['GoogleDrive','OneDrive','Dropbox','Box','PCloud','GoogleWorkspace'].includes(this.auth.type)
        },
    },
    watch: {
        'auth.show'(val) {
            if (val && this.hidePopup) {
                this.$nextTick(() => {
                    this.$emit('submit');
                });
            }
        }
    },
};
</script>

<style>
.lite_popup_box {
  width: 680px;
}

.add_drive .el-form-item__label {
  position: relative;
  top: 10px;
}

.switch-box {
  padding-top: 10px;
}
/* 密码眼睛位置调整 */
.lite_popup.add_drive .el-icon-view::before {
    position: relative;
    top: 7px;
}
.el-input__inner[type=password] {
    height: 40px;
}
.el-input__inner:focus {
  border-color: #5166BD;
}
.el-textarea__inner:focus {
  border-color: #5166BD;
}
/* 站点 */
.website_box {
    border-top: 1px solid rgba(0, 0, 0, 0.08);
    margin-bottom: 20px;
}
/* 标题栏 */
.website_box_title {
    margin-top: 30px;
}
/* 标题栏文字 */
.website_box_title_text {
    font-size: 14px;
    font-weight: bold;
    color: #333333;
    height: 20px;
    line-height: 20px;
    display: inline-block;
}
/* 标题栏添加文字 */
.website_box_title_add {
    font-size: 14px;
    font-weight: normal;
    color: #5562B4;
    float: right;
    height: 20px;
    line-height: 20px;
    padding-left: 26px;
    background-image: url("../../assets/images/lite/icon/add.svg");
    background-position: left center;
    background-repeat: no-repeat;
    background-size: 16px;
    cursor: pointer;
    user-select: none;
}
.website_box_title_add:hover {
    text-decoration: underline;
}
/* 子集合 */
.website_items {
    max-height: 245px;
    overflow: auto;
}
/* 子节点 */
.website_item2 {
    padding: 10px;
    padding-left: 0px;
    border: 1px solid #5166BD;
    border-radius: 6px;
    margin-top: 20px;
    margin-right: 10px;
}
/* 输入框间距 */
.website_item2 .el-form-item {
    margin-bottom: 0px;
}
/* Label 左对齐 */
.website_item2 .el-form-item__label {
    text-align: left;
    padding-left: 10px;
    padding-right: 0px;
}
/* Host 前缀 */
.website_host_prefix {
    display: inline-block;
    width: 35px;
    height: 40px;
    line-height: 40px;
    background-color: #e6e7eb;
    padding: 0 10px;
    vertical-align: middle;
    border-radius: 4px;
    color: #606266;
    position: relative;
    top: -1px;
}
/* Host 宽度 */
.website_host {
    width: 250px;
}
/* 数据库 Host 宽度 */
.website_item_db .website_host {
    width: 309px;
}
/* Port 宽度 */
.website_port {
    width: 103px;
    margin-left: 5px;
}
/* 更多 */
.website_more {
    padding-top: 20px;
    padding-bottom: 10px;
    user-select: none;
}
/* 更多-按钮 */
.website_more_btn {
    font-size: 14px;
    font-weight: normal;
    color: #5562B4;
    display: inline-block;
    cursor: pointer;
    margin-left: 10px;
    padding-right: 26px;
    background-image: url("../../assets/images/lite/icon/more.svg");
    background-position: right center;
    background-repeat: no-repeat;
    background-size: 16px;
}
.website_more_btn:hover {
    text-decoration: underline;
}
/* 更多-删除 */
.website_more_remove {
    font-size: 14px;
    font-weight: normal;
    color: #F56C6C;
    float: right;
    height: 20px;
    line-height: 20px;
    padding-left: 26px;
    background-image: url("../../assets/images/lite/icon/remove.svg");
    background-position: left center;
    background-repeat: no-repeat;
    background-size: 16px;
    cursor: pointer;
}
.website_more_remove:hover {
    text-decoration: underline;
}
/* 提示文字 */
.website_more_content>ul {
    color: #606266;
}
</style>


// WEBPACK FOOTER //
// src/components/workspace/lite_add_drive.vue